export default {
  prev: {
    id: 'paginationTailless.prev',
    defaultMessage: 'previous',
  },
  next: {
    id: 'paginationTailless.next',
    defaultMessage: 'next',
  },
};
